
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/informazioni-personali",
      function () {
        return require("private-next-pages/dashboard/informazioni-personali.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/informazioni-personali"])
      });
    }
  